import { Component, h } from 'preact'
import flatpickr from 'flatpickr'
import { Instance } from 'flatpickr/dist/types/instance'
import Icon from '../assets'
import classnames from 'classnames'

export interface TimepickerV2Props {
  value?: Date
  onClose: (dates: Date[]) => void
  input?: HTMLInputElement
  disableInput?: boolean
}

const fpConfig = {
  enableTime: true,
  noCalendar: true,
  dateFormat: 'H:i',
  static: true
}

export default class TimepickerV2 extends Component<TimepickerV2Props, { selectedDates: Date[] }> {
  private input: HTMLInputElement | null = null
  private closed: number = 0
  private instance: Instance | null = null

  componentDidMount(): void {
    if (this.input) {
      const { onClose, value, disableInput } = this.props
      flatpickr(this.input, {
        ...fpConfig,
        defaultDate: value,
        inline: disableInput,
        onReady: (a, b, instance) => {
          this.instance = instance
          this.addHandler()
        },
        onChange: (selectedDates) => {
          this.setState({
            selectedDates: selectedDates
          })
        },
        onClose: () => {
          onClose(this.state.selectedDates)
          this.closed = Date.now()
          this.removeHandler()
        }
      })
    }
  }

  addHandler() {
    window.document.addEventListener('mousedown', this.handleClickOutside)
  }

  removeHandler() {
    window.document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (e: MouseEvent) => {
    if (
      !document
        .querySelector('.control-time-picker-input-wrapper .flatpickr-calendar')
        ?.contains(e.target as HTMLElement)
    ) {
      this.instance?.close()
    }
  }

  toggleOpen() {
    Date.now() - this.closed > 200 && this.instance?.open()
  }

  render() {
    const { disableInput } = this.props
    return (
      <div className='control-time-picker-input-wrapper'>
        {!disableInput && (
          <a onClick={() => this.toggleOpen()}>
            <Icon customClass='icon-calendar' icon='calendar' />
          </a>
        )}
        {!disableInput && (
          <a onClick={() => this.toggleOpen()}>
            <Icon customClass='icon-dropdown' width={16} icon='chevronDown' />
          </a>
        )}
        <input
          className={classnames('control-date-picker', {
            'input-hidden': disableInput
          })}
          placeholder='Select time'
          ref={(input: HTMLInputElement) => (this.input = input)}
        />
      </div>
    )
  }
}
